/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useHistory } from 'react-router-dom' // Npm: react-router-dom for routing.
import { HiCircleStack, HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({
  mncId,
  onMncUpdate,
  onMncDelete,
  PassOnUpdate
}) => {
  // Hook assignment.
  const _historyRef = useHistory()
  const [_anchorEl, _setAnchorEl] = React.useState(null)
  const _open = Boolean(_anchorEl)

  // Event handler - Open menu.
  const _handleClick = (event) => {
    _setAnchorEl(event.currentTarget)
  }

  // Event handler - Close menu.
  const _handleClose = () => {
    _setAnchorEl(null)
  }

  // Return Component.
  return (
    <>
      <IconButton
        onClick={_handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          backgroundColor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem
          onClick={() => {
            // Push mnc id to Redux state.
            PassOnUpdate({ mncId })

            // Execute update handler.
            onMncUpdate()

            // Close menu.
            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiPencil size={18} />
          <span>Mnc Update</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push mnc id to Redux state.
            PassOnUpdate({ mncId })

            // Execute delete handler.
            onMncDelete()

            // Close menu.
            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiTrash size={18} />
          <span>Mnc Delete</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push mnc id to Redux state.
            PassOnUpdate({ mncId })

            // Navigate to Prefix management page.
            _historyRef.push('/network/mcc/mnc/prefix')

            // Close menu.
            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiCircleStack size={18} />
          <span>Manage Prefix</span>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'mncId': PropTypes.string,
  'onMncUpdate': PropTypes.func,
  'onMncDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
